import React from 'react';
import { motion } from 'framer-motion';
import { Button, HStack, Text } from '@chakra-ui/react';

const PreferencesSubmit = ({ 
  isLoading = false, 
  isDisabled = false, 
  onSubmit = () => {} 
}) => {
  return (
    <>
      <motion.div
        whileHover={{ scale: 1.02 }}
        whileTap={{ scale: 0.98 }}
        className="w-full"
      >
        <Button
          type="submit"
          onClick={onSubmit}
          isLoading={isLoading}
          loadingText="Setting Preferences..."
          isDisabled={isDisabled}
          className="w-full bg-gradient-to-r from-rose-800 to-rose-900 hover:from-rose-900 hover:to-rose-950
                   text-white font-semibold py-3 px-8 rounded-xl shadow-lg hover:shadow-xl
                   transition-all duration-300 disabled:opacity-50 disabled:cursor-not-allowed
                   shadow-rose-300/30"
          size="lg"
        >
          Set Preferences
        </Button>
      </motion.div>

      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ delay: 0.6, duration: 0.3 }}
      >
        <HStack spacing={4} color="gray.500" fontSize="sm" textAlign="center">
          <Text>💡</Text>
          <Text>Tip: You can always edit your preferences later</Text>
        </HStack>
      </motion.div>
    </>
  );
};

export default PreferencesSubmit;